import { NgClass } from '@angular/common';
import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { IonItem } from '@ionic/angular/standalone';

@Component({
  selector: 'app-student-slip-consent-info',
  templateUrl: './student-slip-consent-info.component.html',
  styleUrls: ['./student-slip-consent-info.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [NgClass, IonItem]
})
export class StudentSlipConsentInfoComponent {
  @Input() question: string;
  @Input() response: { accepted: boolean };

  get consentStatus(): string {
    return this.response ? (this.response.accepted ? 'APPROVED' : 'DECLINED') : 'NO RESPONSE GIVEN';
  }

  get statusClass(): string {
    return this.response ? (this.response.accepted ? 'accepted' : 'declined') : 'no-response';
  }
}
